import React from "react"

const InfoText = ({
  info = info
}) => {
  return <span>{info}</span>
}

export default InfoText